import { useMemo } from 'react';

import {
  selectEntriesBySlugs,
  selectPublishedSlugs,
} from '@staticcms/core/reducers/selectors/entries';
import { useAppSelector } from '@staticcms/core/store/hooks';

export default function usePublishedEntries(collectionName: string) {
  const slugs = useAppSelector(state => selectPublishedSlugs(state, collectionName));
  const entries = useAppSelector(selectEntriesBySlugs);

  return useMemo(
    () => slugs && slugs.map(slug => entries[`${collectionName}.${slug}`]),
    [collectionName, entries, slugs],
  );
}
